import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '&&': {
      [theme.breakpoints.down('laptop')]: {
        background: theme.palette.custom.white,
        border: `1px solid ${theme.palette.custom.grey}`,
        borderRadius: '15px',
        padding: SPACES.xxl,
        width: '100%',
      },
    },
  },
  sectionTitle: {
    display: 'flex',
    justifyContent: 'center',
    '&&': {
      marginBottom: SPACES.xs,

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.38,
      color: theme.palette.custom.black,

      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
}))

export default useStyles
